/** #999 — bypass wall-clock when exclusive engine reports EOS. */

import { useMaestroStore } from '../store/maestroStore';
import { diagnosticLog } from '../utils/diagnosticLogger';
import { TransportCommand } from './TransportCommand';

export function allowAdvanceForExclusiveEngineEnd(
  trustExclusiveEngineEnd: boolean | undefined,
  path: string,
  rendererId: string | undefined,
  capturedTrackId: string | null | undefined,
  clearStalledStartWatch: () => void,
): boolean {
  if (!trustExclusiveEngineEnd || !TransportCommand.isExclusiveActive()) {
    return false;
  }
  diagnosticLog('info', 'playback', '[playback] advance reason=exclusive_engine_end', {
    path,
    trackId: capturedTrackId != null ? String(capturedTrackId) : null,
    rendererId: rendererId || useMaestroStore.getState().activeConnectorRenderer?.id || 'unknown',
  });
  clearStalledStartWatch();
  return true;
}
